<template>
  <div v-if="pageContent?.slug === $route.name" class="page-content">
    <div v-html="pageContent?.content" />
  </div>
</template>

<script setup>
  const pageContent = usePageContentStore().getCurrentPage;
</script>
